import { Link } from "react-router-dom";

import { Nav, Navbar, Container } from 'react-bootstrap';
import Pattern from 'style/bluepattern.png'

function MiddleLine() {
    return (
        <div className="d-none d-xl-block" style={{ background: `url(${Pattern})`, backgroundRepeat: "repeat" }}>
            <Navbar key="md" expand="xl">
                <Container>
                    <Nav className="container justify-content-between flex-grow-1 px-5 pl-3">
                        <Link to="/matchschedule" style={{ textDecoration: 'none' }}>
                            <Nav.Link style={{ color: "rgb(255,255,255)" }} href="#action1">b-Sports 대회 <br />일정 안내</Nav.Link>
                        </Link>
                        <Link to="/refereenotice" style={{ textDecoration: 'none' }}>
                            <Nav.Link style={{ color: "rgb(255,255,255)" }} href="#action2">b-Sports 심판과정 <br />일정 안내</Nav.Link>
                        </Link>
                        <Link to="/coachnotice" style={{ textDecoration: 'none' }}>
                            <Nav.Link style={{ color: "rgb(255,255,255)" }} href="#action3">b-Sports 코치과정 <br />일정 안내</Nav.Link>
                        </Link>
                    </Nav>
                </Container>
            </Navbar>
        </div>
    );
}

export default MiddleLine;